import { createSelector } from 'reselect'
import { memoize } from '@exodus/basic-utils'
import { MY_STATE } from '@exodus/redux-dependency-injection'

const selectorFactory = (selfSelector, createExperimentEnabledSelector) =>
  memoize((experimentId) =>
    createSelector(
      selfSelector,
      createExperimentEnabledSelector(experimentId),
      ({ loading, variants }, enabled) => {
        if (!loading && enabled && variants?.[experimentId]?.value !== undefined) {
          return variants[experimentId].value
        }
      }
    )
  )

const createExperimentVariantSelectorDefinition = {
  id: 'createExperimentVariant',
  selectorFactory,
  dependencies: [{ selector: MY_STATE }, { selector: 'createExperimentEnabled' }],
}

export default createExperimentVariantSelectorDefinition
